<template>
  <div>
    <div class="row">
      <div class="col-md-7">
        <div class="row">
          <div class="col-md-12 mb-5">
            <vi-card no-header>
              <div class="row">
                <div class="col-md-6">
                  <div class="d-flex align-center">
                    <div class="auth-title">你好，{{ user.name }}</div>
                    <div class="ml-5" v-if="approveApply">
                      <vi-icon name="fas:shield-alt" color="danger"></vi-icon>
                      <span class="ml-1 text-danger">待认证</span>
                      <span @click="eCertification()" class="ml-4 text-primary pointer"
                        >申请认证</span
                      >
                    </div>
                    <div class="ml-5 text-success" v-if="Approve">
                      <vi-icon name="fas:shield-alt" color="success"></vi-icon>
                      <span class="ml-1">已认证</span>
                    </div>
                  </div>
                  <div class="mt-5 text-color">
                    <div class="row ml-0 test-round">
                      <span>
                        手机号：
                        {{ mobileText(account.mobile) }}
                      </span>
                      <span class="mr-8"
                        >邮箱：
                        {{ account.email }}
                      </span>
                    </div>
                    <div class="mt-2">
                      账号状态：<span class="text-success">正常</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="auth-title">服务流程</div>
                  <div class="d-flex s-bet mt-5">
                    <div class="step-icon text-success">
                      <svg
                        t="1618297813591"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="2042"
                        width="32"
                        height="32"
                      >
                        <path
                          d="M899.509173 196.331527l-38.363749-0.596588c-0.919952 0-86.925768-1.790786-175.753863-36.301787C594.288656 123.999129 535.57544 83.303264 535.032064 82.922594l-23.112394-16.060791-23.063275 16.060791c-0.542352 0.379647-59.307757 41.076534-150.359496 76.510558-88.773859 34.564213-174.832887 36.300764-175.591157 36.300764l-38.58069 0.597611 0 374.245589c0 187.907671 252.099668 386.562103 387.645784 386.562103 135.600351 0 387.702066-198.654432 387.702066-386.562103L899.509173 196.331527 899.509173 196.331527zM511.971859 901.574716c-112.593358 0-332.082304-178.686658-332.082304-331.00067L179.889555 250.538103c31.743982-2.169409 103.694687-10.091846 178.737824-39.285748 76.889181-29.953196 132.779096-63.811328 153.398716-77.051887 22.138206 14.380522 76.400041 47.098691 153.23601 77.051887 75.314313 29.248138 147.427724 37.116339 178.7368 39.285748l0.107447 320.035944C844.107375 722.888058 624.564193 901.574716 511.971859 901.574716L511.971859 901.574716z"
                          p-id="2043"
                          fill="#1BC5BD"
                        ></path>
                        <path
                          d="M743.23599 548.391838l-148.622946 148.461263-62.288648-70.64906c-10.202363-11.504008-27.730575-12.590759-39.232536-2.494821-11.55722 10.200316-12.641925 27.727505-2.441609 39.231513l81.826634 92.842525c5.097088 5.750981 12.314467 9.115612 19.966751 9.332553 0.326435 0.054235 0.597611 0.054235 0.871857 0.054235 7.374968 0 14.432711-2.876514 19.640316-8.083096l169.570024-169.298847c10.851139-10.850116 10.851139-28.432563 0.054235-39.337937C771.721765 537.590841 754.090199 537.650193 743.23599 548.391838L743.23599 548.391838z"
                          p-id="2044"
                          fill="#1BC5BD"
                        ></path>
                        <path
                          d="M591.246367 598.789669c12.589736-12.966313 27.999704-26.533306 40.968064-37.275975-18.61087-19.806091-41.240263-35.7052-66.471924-46.718021 30.388101-23.440875 50.300616-59.905368 50.300616-101.146655 0-70.810742-57.625442-128.438231-128.437208-128.438231-70.810742 0-128.438231 57.625442-128.438231 128.438231 0 41.131793 19.805068 77.43358 50.02944 100.929714-70.809719 30.495548-120.569006 100.924597-120.569006 182.807513 0 15.356756 12.42703 27.782763 27.782763 27.782763 15.35471 0 27.780717-12.42703 27.780717-27.782763 0-79.060637 64.299445-143.41227 143.413294-143.41227C528.412296 553.97295 565.09373 571.280128 591.246367 598.789669L591.246367 598.789669zM487.607962 340.776314c40.152489 0 72.874751 32.720216 72.874751 72.872704 0 40.153512-32.724309 72.820516-72.874751 72.820516-40.152489 0-72.873728-32.667004-72.873728-72.820516C414.734234 373.495506 447.455473 340.776314 487.607962 340.776314L487.607962 340.776314z"
                          p-id="2045"
                          fill="#1BC5BD"
                        ></path>
                      </svg>
                      <div>实名认证</div>
                    </div>
                    <span> > </span>
                    <div class="step-icon text-success">
                      <svg
                        t="1618298950222"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="9187"
                        width="32"
                        height="32"
                      >
                        <path
                          d="M566.4 281.3l131 131C661.5 475 634.3 557 619 609.2h-2c-86.3 0-220.6 39.6-321.3 74 35.3-102.5 73-233.2 72.9-323.3 52.2-15.3 134.7-42.6 197.8-78.6m7.8-82.8C507 257 339.9 302.4 303.6 311.1c-3.7 0.9-5.4 4.6-4.2 8 37.3 101-112.6 472.7-112.6 472.7S481 673.2 617 673.2c16.9 0 31.4 1.8 42.6 6 0.7 0.3 1.5 0.4 2.2 0.4 2.6 0 5.1-1.7 5.8-4.6 8.7-36.3 54.1-203.3 112.6-270.5l-206-206z"
                          fill="#1BC5BD"
                          p-id="9188"
                        ></path>
                        <path
                          d="M451.083 491.33l129.47-129.47 36.203 36.204-129.47 129.47zM607.514 167.018l36.203-36.203 204.21 204.21-36.203 36.204zM182.2 813.6h654.5v51.2H182.2z"
                          fill="#1BC5BD"
                          p-id="9189"
                        ></path>
                      </svg>
                      <div>签订合同</div>
                    </div>

                    <span> > </span>

                    <div class="step-icon text-success">
                      <svg
                        t="1618298746321"
                        class="icon"
                        viewBox="0 0 1114 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="7330"
                        width="32"
                        height="32"
                      >
                        <path
                          d="M668.16 382.72v291.84l103.68 52.48 52.48-32-97.28-44.8V418.56l107.52-48.64 197.12 93.44v-60.16l-197.12-94.72-166.4 74.24z"
                          p-id="7331"
                          fill="#1BC5BD"
                        ></path>
                        <path
                          d="M761.6 510.72v-65.28l72.96-32 256 120.32v199.68L921.6 824.32l-34.56-38.4 147.2-89.6V565.76L834.56 473.6l-72.96 37.12z"
                          p-id="7332"
                          fill="#1BC5BD"
                        ></path>
                        <path
                          d="M629.76 494.08l-56.32 33.28v204.8l193.28 92.16 226.56-136.96v-107.52l-51.2-20.48v104.96l-175.36 101.12-136.96-70.4V494.08z"
                          p-id="7333"
                          fill="#1BC5BD"
                        ></path>
                        <path
                          d="M528.64 824.32H189.44c-96-19.2-167.68-102.4-167.68-203.52 0-108.8 85.76-199.68 194.56-206.08 2.56-163.84 136.96-295.68 300.8-295.68 130.56 0 221.44 46.08 280.32 157.44l-66.56 29.44c-43.52-88.32-112.64-120.32-213.76-120.32-129.28 0-234.24 104.96-234.24 234.24 0 8.96 0 16.64 1.28 25.6l5.12 40.96-40.96-5.12c-5.12 0-11.52-1.28-16.64-1.28C153.6 480 89.6 542.72 89.6 620.8c0 75.52 60.16 136.96 135.68 140.8h304.64v62.72h-1.28z"
                          p-id="7334"
                          fill="#1BC5BD"
                        ></path>
                        <path
                          d="M528.64 824.32H189.44c-96-19.2-167.68-102.4-167.68-203.52 0-108.8 85.76-199.68 194.56-206.08 66.56 5.12 71.68 71.68 71.68 71.68l-40.96-5.12c-5.12 0-11.52-1.28-16.64-1.28-78.08 0-142.08 62.72-142.08 140.8 0 75.52 60.16 136.96 135.68 140.8h304.64v62.72z"
                          p-id="7335"
                          fill="#1BC5BD"
                        ></path>
                      </svg>
                      <div>开通云服务</div>
                    </div>

                    <span> > </span>
                    <div class="step-icon text-success">
                      <svg
                        t="1618298992807"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="11436"
                        width="32"
                        height="32"
                      >
                        <path
                          d="M237.358431 284.464797l131.472334 375.310851-27.569916-19.554358L890.249275 640.22129c16.136515 0 29.212322 13.0799 29.212322 29.213345 0 16.129352-13.075807 29.205159-29.212322 29.205159L341.259826 698.639794c-12.409634 0-23.465434-7.836479-27.566846-19.549242L109.05016 94.8963l27.567869 19.553335L77.586564 114.449635c-16.129352 0-29.207206-13.074783-29.207206-29.212322 0-16.129352 13.077853-29.207206 29.207206-29.207206l59.032488 0c12.409634 0 23.466458 7.842619 27.566846 19.555381l52.728922 150.525272 710.724017 0c18.48705 0 32.326243 16.962324 28.612665 35.077913l-46.633087 227.389894c-2.547009 12.408611-12.796444 21.75549-25.382087 23.160489l-431.515944 48.065715c-16.036231 1.786693-30.482245-9.761318-32.266891-25.797549-1.783623-16.030092 9.764388-30.475082 25.798573-32.257681l410.798087-47.145763c0 0 20.75879-96.119151 35.926234-170.074513C893.311007 282.900162 362.038058 284.149619 237.358431 284.464797L237.358431 284.464797zM407.438061 818.372759c23.362081 0 42.36897 19.004843 42.36897 42.3659 0 23.360034-19.006889 42.364877-42.36897 42.364877-23.360034 0-42.363853-19.004843-42.363853-42.364877C365.073184 837.377602 384.078027 818.372759 407.438061 818.372759M407.438061 762.594385c-54.202483 0-98.142228 43.941791-98.142228 98.144274 0 54.207599 43.939745 98.143251 98.142228 98.143251s98.147344-43.936675 98.147344-98.143251C505.584382 806.536176 461.640544 762.594385 407.438061 762.594385L407.438061 762.594385zM816.372707 818.372759c23.357987 0 42.360783 19.004843 42.360783 42.3659 0 23.360034-19.002796 42.364877-42.360783 42.364877-23.360034 0-42.364877-19.004843-42.364877-42.364877C774.007831 837.377602 793.012673 818.372759 816.372707 818.372759M816.372707 762.594385c-54.206576 0-98.143251 43.941791-98.143251 98.144274 0 54.207599 43.937698 98.143251 98.143251 98.143251 54.200436 0 98.139158-43.936675 98.139158-98.143251C914.512888 806.536176 870.573143 762.594385 816.372707 762.594385L816.372707 762.594385zM816.372707 958.88191"
                          p-id="11437"
                          fill="#1BC5BD"
                        ></path>
                      </svg>
                      <div>购买云产品</div>
                    </div>
                  </div>
                </div>
              </div>
            </vi-card>
          </div>
          <div class="col-md-12 mb-5">
            <vi-card no-header>
              <div class="row">
                <div class="col-md-6 vertical-grain">
                  <div class="title" style="font-size: 16px">可用余额</div>
                  <div class="d-flex align-center mt-10 mb-10 text-success">
                    <div class="mr-20 balance">
                      {{ prefix }}{{ wallet.balance | amountFromat }}
                    </div>
                    <div class="buy-btn mr-5" @click="eBuyCheck(wallet.balance)">
                      购买消费额度
                    </div>
                    <div class="buy-btn" @click="eFlowCheck">
                      收支明细
                    </div>
                  </div>
                  <div>
                    近7天消费：{{ prefix }}{{ overview.lastSevenDay | amountFromat }}
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="ml-5">
                    <div class="title" style="font-size: 16px">消费概览</div>
                    <div class="d-flex align-center s-bet mt-10">
                      <div>
                        <div>总消费</div>
                        <div class="text-color">
                          {{ prefix }}{{ overview.total | amountFromat }}
                        </div>
                      </div>
                      <div>
                        <div>本月消费</div>
                        <div class="text-color">
                          {{ prefix }}{{ overview.thisMonth | amountFromat }}
                        </div>
                      </div>
                      <div>
                        <div>上月消费</div>
                        <div class="text-color">
                          {{ prefix }}{{ overview.lastMonth | amountFromat }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </vi-card>
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="row">
          <div class="col-12">
            <vi-card no-header fit body-class="pt-2">
              <div style="font-size: 16px; font-weight: 600">公告</div>
              <div class="text-color mt-5">2022-11-18</div>
              <div class="text-color">尊敬的用户您好，系统已更新，内容如下：</div>
              <div class="mt-4">
                1.订单流程变更,新增订单确认步骤,<span
                  @click="eDialog(0)"
                  class="text-primary link_text"
                >
                  点击查看详情
                </span>
              </div>
              <div class="mt-4">
                2.新增【续费管理】功能,支持自主管理云产品续费设置,
                <span @click="eDialog(1)" class="text-primary link_text"
                  >点击查看详情</span
                >
              </div>
              <div style="height: 173px"></div>
            </vi-card>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-7">
        <vi-card no-header>
          <div v-if="count > 0">
            <div class="flex_line">
              <div style="font-size: 16px; font-weight: 600">
                您有待确认的订单，<span class="text-success">共{{ count }}单</span>
              </div>
              <button type="reset" class="btn btn-primary ml-4" @click="eOrderCheck">
                去确认 <vi-icon name="fas:chevron-right"></vi-icon>
              </button>
            </div>
            <div class="mt-5">
              <table class="table table-head-custom table-vertical-center">
                <thead class="bg-gray-100">
                  <tr>
                    <th>概要</th>
                    <th>类型</th>
                    <th>原价</th>
                    <th>应付金额</th>
                    <th>创建时间</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in batchList" :key="index">
                    <td>{{ item.name }}</td>
                    <td>{{ eTypeSwitch(item.type) }}</td>
                    <td><vi-amount v-model="item.originalAmount" :prefix="prefix" /></td>
                    <td>
                      <vi-amount v-model="item.amount" :prefix="prefix" />
                      {{ eDiscount(item.originalAmount, item.amount) }}
                    </td>
                    <td>{{ eGetTime(item.aliyunTime) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-else class="circle_line">暂无订单需要确认</div>
        </vi-card>
      </div>
      <div class="col-md-5">
        <vi-card no-header>
          <div style="font-size: 16px; font-weight: 600">常用</div>
          <div class="row mt-8">
            <div style="text-align: center">
              <div class="circle-box" @click="eOrderCheck">
                <span class="svg-icon svg-icon-xl svg-icon-primary">
                  <!--begin::Svg Icon | path:assets/media/svg/icons/General/Search.svg-->

                  <svg
                    t="1668674566348"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2626"
                    width="35"
                    height="35"
                  >
                    <path
                      d="M240 286.72h-45.44L128 219.52l45.44-44.8 44.16 43.52L307.84 128l45.44 45.44-113.28 113.28zM447.36 192h512v64h-512V192z m0 192h512v64h-512V384z m512 192h-512v64h512V576z m-512 192h512v64h-512v-64zM194.56 478.72h45.44l113.28-113.28-45.44-44.8L217.6 410.88l-44.16-44.16-45.44 45.44 66.56 66.56z m45.44 192.64h-45.44L128 604.8l45.44-45.44 44.16 44.16 90.24-90.88 45.44 45.44-113.28 113.28z m-45.44 192.64h45.44l113.28-113.28-45.44-45.44-90.24 90.88-44.16-44.16-45.44 44.8 66.56 67.2z"
                      p-id="2627"
                      fill="#1BC5BD"
                    ></path>
                  </svg>
                  <!--end::Svg Icon-->
                </span>
                <span class="circle_tips" v-if="count > 0">
                  {{ count }}
                </span>
              </div>
              <div class="mt-4">待确认订单</div>
            </div>
            <div class="ml-10" style="text-align: center">
              <div class="circle-box" @click="eRenew">
                <span class="svg-icon svg-icon-xl svg-icon-primary">
                  <svg
                    t="1668674925289"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5868"
                    width="35"
                    height="35"
                  >
                    <path
                      d="M554.453333 128C342.186667 128 170.666667 299.946667 170.666667 512H42.666667l166.186666 166.186667 2.986667 6.186666L384 512h-128c0-164.906667 133.76-298.666667 298.666667-298.666667s298.666667 133.76 298.666666 298.666667-133.76 298.666667-298.666666 298.666667c-82.56 0-157.013333-33.706667-210.986667-87.68l-60.373333 60.373333C352.64 852.906667 448.426667 896 554.453333 896 766.72 896 938.666667 724.053333 938.666667 512S766.72 128 554.453333 128zM512 341.333333v213.333334l182.613333 108.373333L725.333333 611.2l-149.333333-88.533333V341.333333h-64z"
                      p-id="5869"
                      fill="#1BC5BD"
                    ></path>
                  </svg>
                </span>
              </div>
              <div class="mt-4">续费管理</div>
            </div>
            <div class="ml-10" style="text-align: center">
              <div class="circle-box" @click="eJump">
                <span class="svg-icon svg-icon-xl svg-icon-primary">
                  <!--begin::Svg Icon | path:assets/media/svg/icons/General/Search.svg-->
                  <svg
                    t="1616572590430"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="1555"
                    width="35"
                    height="35"
                  >
                    <path
                      d="M959.2 383.9c-0.3-82.1-66.9-148.6-149.1-148.6H575.9l21.6 85.2 201 43.7c18.3 4.2 32.1 20.3 32.9 39.7 0.1 0.5 0.1 216.1 0 216.6-0.8 19.4-14.6 35.5-32.9 39.7l-201 43.7-21.6 85.3h234.2c82.1 0 148.8-66.5 149.1-148.6V383.9zM225.5 660.4c-18.3-4.2-32.1-20.3-32.9-39.7-0.1-0.6-0.1-216.1 0-216.6 0.8-19.4 14.6-35.5 32.9-39.7l201-43.7 21.6-85.2H213.8c-82.1 0-148.8 66.4-149.1 148.6V641c0.3 82.1 67 148.6 149.1 148.6H448l-21.6-85.3-200.9-43.9z m200.9-158.8h171v21.3h-171z"
                      p-id="1556"
                      fill="#FF6A00"
                    ></path>
                  </svg>
                  <!--end::Svg Icon-->
                </span>
              </div>
              <div class="mt-4">阿里云控制台</div>
            </div>
            <div class="ml-10" style="text-align: center">
              <div class="circle-box">
                <a
                  href="https://loss-sz-devops.oss-cn-shenzhen.aliyuncs.com/solutions/Devops/deploy/publish/Leistar.Shiyun.WinInstaller.exe"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="../../assets/logo.png" width="35" height="35" />
                </a>
              </div>
              <div class="mt-4">
                <a
                  style="color: #3f4254"
                  href="https://loss-sz-devops.oss-cn-shenzhen.aliyuncs.com/solutions/Devops/deploy/publish/Leistar.Shiyun.WinInstaller.exe"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  客户端下载
                </a>
              </div>
            </div>
          </div>
        </vi-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
var moment = require("moment");
export default {
  name: "OverviewCustomerClt",
  data() {
    return {
      wallet: {},
      overview: {
        lastMonth: 0,
        lastSevenDay: 0,
        thisMonth: 0,
        today: 0,
        total: 0,
        yesterday: 0,
      },
      iconSize: "15px",
      prefix: "",
      approveApply: false,
      Approve: false,
      batchList: [],
      count: 0,
      newArticleBool: false,
      timer: null,
    };
  },
  filters: {
    amountFromat(val) {
      if (val) {
        if (String(val) === "0") {
          return "0.00";
        }
        let numb = val.toFixed(5);
        let newStr = numb.split("");
        let index = newStr.indexOf(".") + 3;
        newStr.splice(index);
        let value = newStr.join("");
        return value;
      }
      return "0.00";
    },
  },
  computed: {
    ...mapGetters({
      user: "currentUser",
      account: "currentAccount",
    }),
  },
  destroyed() {
    clearInterval(this.timer);
  },
  watch: {},
  mounted() {
    if (this.user) {
      this.oGetWallet().then((r) => {
        this.wallet = r.data.wallet;
      });
      this.oGetFlowOverview();
      this.oGetApplyCurrent();
      // this.eGetToConfirmed();
      this.eGetOrder();
      this.prefix = this.$$.currency.prefix();
      let bool = window.localStorage.getItem("NoticeDialog");
      if (bool) {
        this.newArticleBool = false;
      } else {
        this.newArticleBool = true;
      }
      this.timer = window.setInterval(() => {
        this.eGetOrder();
      }, 5000);
    }
  },
  methods: {
    eGetToConfirmed() {
      this.$$.api
        .post("/shiyun/marketing/apis/biz/order/customer/tbcStatistic")
        .then((res) => {
          this.count = res.data.count;
        })
        .catch((e) => {});
    },
    oGetWallet() {
      let userSN = this.user.sn;
      return new Promise((resolve) => {
        this.$$.api
          .post("/kernel/enterprise/apis/biz/customer/wallet/default", {
            // columns: ["*", "balance"],
            userSN: userSN,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((e) => {
            this.$$.toastr.error(`错误信息：${e.message}`);
          });
      });
    },
    oGetFlowOverview() {
      this.$$.api
        .post("shiyun/marketing/apis/biz/customer/wallet/flow/overview")
        .then((res) => {
          this.overview = res.data;
        })
        .catch((e) => {
          this.$$.toastr.error(`错误信息：${e.message}`);
        });
    },
    mobileText(item) {
      let result = "";
      let mobile = item.slice(item.indexOf("-") + 1);
      result = mobile;
      return result;
    },
    oGetApplyCurrent() {
      this.$$.api
        .post("/shiyun/marketing/apis/biz/principal/apply/current")
        .then((res) => {
          let data = res.data;
          if (data.approveStatus === "Unknow") {
            this.approveApply = true;
          }
          if (data.approveStatus === "Approve") {
            this.Approve = true;
          }
        })
        .catch(() => {});
    },
    eCertification() {
      this.$$.navigate.to({
        label: `实名认证`,
        //  path: `/customer/certification/submit`,
        path: `/shiyun/account/principal/submit`,
      });
    },
    eGetOrder() {
      let userSN = this.user.sn;
      return new Promise((resolve) => {
        this.$$.api
          .post("/shiyun/marketing/apis/biz/order/page", {
            requirement: {
              filters: [
                {
                  name: "userSN",
                  type: "Equal",
                  value: userSN,
                },
                {
                  name: "confirmStatus",
                  type: "Equal",
                  value: "Off",
                },
              ],
            },
            pageIndex: 1,
            pageSize: 3,
            columns: ["*"],
            orderBy: { name: "ID", type: "Ascending" },
          })
          .then((res) => {
            let list = res.data.page.items;
            this.count = res.data.page.total;
            let arr = [];
            if (list && list.length > 0) {
              list.map((p) => {
                arr.push(p);
              });
              this.batchList = arr;
            }
          });
      });
    },
    eTypeSwitch(type) {
      let result = "";
      switch (type) {
        case "New":
          result = "新购";
          break;
        case "Renew":
          result = "续费";
          break;
        case "Upgrade":
          result = "升级";
          break;
        case "Refund":
          result = "退款";
          break;
        default:
          break;
      }
      return result;
    },
    eSourceTypeSwitch(type) {
      let result = "";
      switch (type) {
        case "System":
          result = "系统";
          break;
        case "Aliyun":
          result = "阿里云";
          break;
        case "Tencent":
          result = "腾讯云";
          break;
        case "Custom":
          result = "人工补录";
          break;
        default:
          break;
      }
      return result;
    },
    eStatusSwitch(type) {
      let result = "";
      switch (type) {
        case "New":
          result = "新订单";
          break;
        case "Paid":
          result = "已开通";
          break;
        case "Canceled":
          result = "已取消";
          break;
        case "Remove":
          result = "作废";
          break;
        default:
          break;
      }
      return result;
    },
    eDiscount(val1, val2) {
      let result = "";
      let num = val2 / val1;
      if (val1 == 0 && val2 == 0) {
        return "";
      }
      result = (num.toFixed(2) * 100) / 10;

      if (result == "10") {
        return "";
      } else {
        return `（${result}折）`;
      }
    },
    eRenew() {
      this.$$.navigate.to({ path: "/shiyun/cost/renew" });
    },
    eOrderCheck() {
      this.$$.navigate.to({
        label: `我的订单`,
        path: `/shiyun/cost/${true}/order`,
      });
    },
    eFlowCheck() {
      this.$$.navigate.to({
        label: `收支明细`,
        path: `/shiyun/wallet/flow`,
      });
    },
    eBuyCheck(val1) {
      let limit = `${this.eAmountFromat(val1)}`
      this.$$.navigate.to({
        label: `购买消费额度`,
        path: `/shiyun/wallet/${limit}/purchase`,
      });
    },
    eGetTime(time) {
      let result = "";
      let m = moment(time).format("YYYY-MM-DD");
      if (m === "0009-01-01") {
        return result;
      } else if (m === "9999-01-01") {
        return result;
      }
      result = moment(time).format("YYYY-MM-DD HH:mm:ss");
      return result;
    },
    eAmountFromat(val){
      if (val) {
        if (String(val) === "0") {
          return "0.00";
        }
        let numb = val.toFixed(5);
        let newStr = numb.split("");
        let index = newStr.indexOf(".") + 3;
        newStr.splice(index);
        let value = newStr.join("");
        return value;
      }
    },
    eJump() {
      this.$$.swal.fire({
        icon: "info",
        // text: "正在打开阿里云，请勿关闭页面...",
        html: `
          <div id="t">正在获取阿里云登录链接...</div>
          <a style="display: none;" href="https://www.baidu.com" target="_blank">123123</a>
        `,
        showLoaderOnConfirm: true,
        showCloseButton: true,
        allowOutsideClick: false,
        didOpen: () => {
          this.$$.swal.Swal.showLoading();

          this.$$.api
            .post("/shiyun/aliyun/apis/biz/ramuser/samlsp/login")
            .then((res) => {
              const content = this.$$.swal.Swal.getContent();
              if (content) {
                const t = content.querySelector("#t");
                if (t) {
                  t.textContent = "获取成功，正在打开阿里云...";
                  const a = content.querySelector("a");
                  if (a) {
                    a.href = res.data.loginUrl;
                    a.textContent = res.data.loginUrl;
                    a.click();
                    this.$$.swal.success("打开成功");
                  } else {
                    this.$$.swal.error("打开阿里云失败，获取不到对应链接。");
                  }
                } else {
                  this.$$.swal.error("获取阿里云登录链接失败。");
                }
              }
            })
            .catch((err) => {
              this.$$.swal.error("获取登录配置失败：" + err.message);
            });
        },
        willClose: () => {},
      });
    },
    eDialog(val) {
      this.$emit("e-dialog", val);
    },
  },
};
</script>
<style lang="scss" scoped>
.step-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 64px;
  width: 72px;
}

.align-center {
  align-items: center;
}
.auth-title {
  font-size: 15px;
  font-weight: 500;
}
.text-color {
  color: #9e9e9e;
}
.pointer {
  cursor: pointer;
}
.title {
  font-size: 15px;
  font-weight: 600;
}
.balance {
  font-size: 25px;
}

.vertical-grain {
  border-right: solid 1px #bbbbbb;
}
.s-bet {
  justify-content: space-between;
  align-items: center;
}
.title-sub {
  font-size: 15px;
}
.icon-width {
  width: 15px;
}
.text-flex {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  height: 100%;
}
.test-round {
  justify-content: space-between;
}
.circle-box {
  width: 65px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f7f7;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
}
.circle_tips {
  min-width: 20px;
  min-height: 20px;
  line-height: 20px;
  border-radius: 3px;
  text-align: center;
  background: red;
  color: #fff;
  position: absolute;
  top: -5px;
  right: 0px;
}
.circle_line {
  height: 150px;
  line-height: 150px;
  text-align: center;
  color: #bfbfbf;
  font-size: 18px;
}
.flex_line {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.link_text {
  cursor: pointer;
}
.link_text:hover {
  color: #3699ff;
}
.buy-btn{
  background: #1BC5BD;
  color: #fff !important;
  padding: 5px 10px;
  border-radius: 8px;
  cursor: pointer;
}
</style>
